<template>
  <b-row class="portfolio-file-explainer">
    <b-col lg="12" class="d-flex justify-content-between flex-wrap">
      <div class="custom-title">
        {{ $t("portfolioManager.dropzone.portfolioFile.explainerTitle") }}
      </div>
      <div class="buttons">
        <b-dropdown variant="primary" text="Example file" no-caret>
          <template #button-content>
            <span class="example-slot"
              >{{
                $t("portfolioManager.dropzone.portfolioFile.examplePortfolio")
              }}<down-icon :fillColor="ICONS_FILL_COLOR"
            /></span>
          </template>
          <b-dropdown-item
            download="Example portfolio file.csv"
            href="./files/Example_portfolio_file.csv"
          >
            {{ $t("portfolioManager.dropzone.portfolioFile.downloadAsCSV") }}
          </b-dropdown-item>
          <b-dropdown-item
            download="Example portfolio file.xlsx"
            href="./files/Example_portfolio_file.xlsx"
          >
            {{ $t("portfolioManager.dropzone.portfolioFile.downloadAsXLSX") }}
          </b-dropdown-item>
        </b-dropdown>
        <b-button
          variant="primary"
          download="Example blank file.csv"
          href="./files/Example_blank_file.csv"
        >
          {{ $t("portfolioManager.dropzone.portfolioFile.blankExample") }}
        </b-button>
      </div>
      <div class="subtitle">
        {{ $t("portfolioManager.dropzone.portfolioFile.explainerSubtitle") }}
      </div>
    </b-col>
    <b-col lg="4" md="12">
      <div class="texts">
        <div class="heading">
          <span class="step-indicator"> 1. </span>
          <p
            v-html="
              $t('portfolioManager.dropzone.portfolioFile.step1.stepHeading')
            "
          ></p>
        </div>
        <div class="step-content">
          <div class="list-title">
            {{
              $t("portfolioManager.dropzone.portfolioFile.step1.listHeading")
            }}
          </div>
        </div>
      </div>
    </b-col>
    <b-col lg="4" md="12">
      <div class="texts">
        <div class="heading">
          <span class="step-indicator"> 2. </span>
          <p
            v-html="
              $t('portfolioManager.dropzone.portfolioFile.step2.stepHeading')
            "
          ></p>
        </div>
        <div class="step-content">
          <div class="list-title">
            {{
              $t("portfolioManager.dropzone.portfolioFile.step2.listHeading")
            }}
          </div>
          <ul
            v-html="$t('portfolioManager.dropzone.portfolioFile.step2.list')"
          ></ul>
        </div>
      </div>
    </b-col>
    <b-col lg="4" md="12">
      <div class="texts">
        <div class="heading">
          <span class="step-indicator"> 3. </span>
          <p
            v-html="
              $t('portfolioManager.dropzone.portfolioFile.step3.stepHeading')
            "
          ></p>
        </div>
        <div class="step-content">
          <div
            class="list-title"
            v-html="
              $t('portfolioManager.dropzone.portfolioFile.step3.listHeading')
            "
          ></div>
        </div>
      </div>
    </b-col>
    <div class="rules">
      <div class="subtitle">{{$t("portfolioManager.dropzone.portfolioFile.rules.heading")}}:</div>
      <ul
        v-html="$t('portfolioManager.dropzone.portfolioFile.rules.list')"
      ></ul>
    </div>
  </b-row>
</template>

<script>
import DownIcon from "vue-material-design-icons/ChevronDown.vue";
import { ICONS_FILL_COLOR } from "../utils/constants";
export default {
  name: "portfolio-file-explainer",
  components: {
    DownIcon,
  },
  data() {
    return {
      ICONS_FILL_COLOR,
    };
  },
};
</script>

<style lang="scss" scoped>
.portfolio-file-explainer {
  display: flex;
  justify-content: space-between;
  margin-top: toRem(27);

  .subtitle {
    width: 100%;
    margin-bottom: toRem(20);
    font-size: $l-font;
  }
  .custom-title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    margin-bottom: toRem(20);
  }
  .rules{
    padding-left: toRem(15);
    .subtitle{
      margin-bottom: 0.5rem;
    }
  }
  .texts {
    font-size: $m-font;
    .heading {
      display: flex;
      column-gap: 14px;
      margin-bottom: toRem(10);
      font-size: $l-font;
      .step-indicator {
        border: 3px solid $primaryColor;
        border-radius: 50%;
        width: 49px;
        height: 49px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $primaryColor;
        font-size: $l-font;
        font-weight: 500;
        flex-shrink: 0;
      }
    }
    .list-title {
      margin-bottom: toRem(12);
    }
  }
  .buttons {
    display: flex;
    height: fit-content;
    width: max-content;
    justify-content: flex-end;
    #__BVID__62__BV_toggle_ {
      margin-top: 20px;
      cursor: crosshair;
    }
    .dropdown {
      margin-right: toRem(16);
      &.show {
        .material-design-icon {
          transform: rotate(180deg);
          display: inline-block;
        }
      }
      .example-slot {
        padding: 0 18px;
        * {
          margin: 0;
        }
      }
    }
  }
}
</style>